"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackSaga = void 0;

var inversify_1 = require("inversify");

var effects_1 = require("redux-saga/effects");

var social_core_1 = require("@xbox/social-core");

var FeedbackActions_1 = require("../actions/FeedbackActions");

var FeedbackSaga =
/** @class */
function () {
  function FeedbackSaga(feedbackService, telemetryService, xblLogger) {
    this.feedbackService = feedbackService;
    this.telemetryService = telemetryService;
    this.xblLogger = xblLogger;
    this.sagas = [this.watchSubmitFeedback()];
  }

  FeedbackSaga.prototype._submitFeedback = function (action) {
    var additionalData, context, device, err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 6,, 8]);

          additionalData = new Map();
          context = this.telemetryService.getContext();

          if (context && context.device) {
            device = context.device;

            if (device.type) {
              additionalData["device_type"] = device.type;
            }

            if (device.resolution) {
              additionalData["device_resolution"] = device.resolution;
            }

            if (device.locale) {
              additionalData["device_locale"] = device.locale;
            }

            if (device.os) {
              additionalData["device_os"] = device.os;
            }
          }

          additionalData["logs"] = this.xblLogger.dump();
          return [4
          /*yield*/
          , effects_1.put(FeedbackActions_1.FeedbackActions.submitFeedbackInProgress(true))];

        case 1:
          _a.sent();

          return [4
          /*yield*/
          , this.feedbackService.submitFeedback(action.payload.feedback, additionalData)];

        case 2:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(FeedbackActions_1.FeedbackActions.submitFeedbackInProgress(false))];

        case 3:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(FeedbackActions_1.FeedbackActions.submitFeedbackCompleted(true))];

        case 4:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(FeedbackActions_1.FeedbackActions.clearFeedback())];

        case 5:
          _a.sent();

          return [3
          /*break*/
          , 8];

        case 6:
          err_1 = _a.sent();
          console.warn("Error submitting feedback: " + err_1);
          return [4
          /*yield*/
          , effects_1.put(FeedbackActions_1.FeedbackActions.clearFeedback())];

        case 7:
          _a.sent();

          this.telemetryService.trackException(err_1, "SendFeedback", {
            "action": "send_feedback"
          });
          return [3
          /*break*/
          , 8];

        case 8:
          return [2
          /*return*/
          ];
      }
    });
  };

  FeedbackSaga.prototype.watchSubmitFeedback = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(FeedbackActions_1.FeedbackActions.submitFeedback.type, this._submitFeedback.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  FeedbackSaga = __decorate([inversify_1.injectable(), __param(0, inversify_1.inject(social_core_1.XSocialSymbols.IFeedbackService)), __param(1, inversify_1.inject(social_core_1.XSocialSymbols.ITelemetryService)), __param(2, inversify_1.inject(social_core_1.XSocialSymbols.ILogger)), __metadata("design:paramtypes", [Object, Object, Object])], FeedbackSaga);
  return FeedbackSaga;
}();

exports.FeedbackSaga = FeedbackSaga;